export const PropertyFlags = {
  noMultiEdit: 'NoMultiEdit'
};
